import type { FC } from "react";

import { Alert } from "@hightouch/htui";
import { useFlags } from "launchdarkly-react-client-sdk";

import { useUser } from "src/contexts/user-context";
import { useEntitlements } from "src/hooks/use-entitlement";
import * as analytics from "src/lib/analytics";

export const OverageBanner: FC = () => {
  const { workspace } = useUser();
  const isBillingPage = location.pathname.endsWith("/settings/billing");
  const { data: entitlementsData, isLoading: loadingEntitlements } =
    useEntitlements(!isBillingPage);
  const { appShowOverageBanner } = useFlags();

  if (!appShowOverageBanner || !workspace || loadingEntitlements) {
    return null;
  }

  analytics.track("Overage Banner Shown", {
    workspace_id: workspace.id,
    ...entitlementsData.overage,
  });

  return (
    <Alert
      variant="banner"
      type="error"
      title="ACTION REQUIRED: You are currently in excess of your monthly sync limit."
      message="Please check your email inbox for instructions to remediate."
    />
  );
};
